import { useLocation, useNavigate } from "react-router-dom";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim.jsx";
import SectionTitle from "../../components/SectionTitle/SectionTitle.jsx";

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const errorMessage = location.state?.message || "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
  const errorStatus = location.state?.status || 500;
  const astorId = location.state?.astorId || null;
  const buttonText = location.state?.buttonText || null;
  const buttonLink = location.state?.link || null;
  return (
    <>
      <PageTitleSlim title={`Fehler ${errorStatus}`} />
      <section className="container narrow">
        <SectionTitle title={`Ups...ein ${errorStatus} Fehler`} />
        <div className="section-inner">
          <div className="form-container">
            <h3>{errorMessage}</h3>
            { astorId &&
              <>
                <hr />
                <p>
                  Zurück zum <a href={`https://onb.digital/result/${astorId}`}>digitalisierten Objekt</a>
                </p>
              </>
            }
            <hr />
            <p>Hier gelangen Sie zu den digitalisierten Objekten der Österreichischen Nationalbibliothek: <a href="https://onb.digital">onb.digital</a></p>
            <p>Hier geht es zum <a href="https://search.onb.ac.at">Katalog</a> und hier zur Startseite <a href="https://www.onb.ac.at/">onb.ac.at</a></p>
            {buttonText && buttonLink && (
                <a
                    href={buttonLink}
                    className="button primary hollow"
                    style={{ display: "inline-block", textDecoration: "none" }}
                >
                  {buttonText}
                </a>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ErrorPage;
